import { render } from "./RecordListingButton.vue?vue&type=template&id=016d48b4"
import script from "./RecordListingButton.vue?vue&type=script&lang=js"
export * from "./RecordListingButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__